import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import Header from './Header';
import Auth from '../../shared/Auth';
import TableLoader from '../Loaders/TableLoader';
import ChartLoader from '../Loaders/ChartLoader';
import AppWidget from '../Custom/AppWidget';
import Table from './Table';
import HeatMap from './HeatMap';
import HeatMap2 from './HeatMap2';
import Details from './Details';
import { constants } from '../../shared/constants';
import { session } from '../../Service/APIService';
import Axios from '../../utils/axiosClient';

const exportObj = [
  {
    id: 1,
    title: 'Alerts Table',
    key: 'TABLE_OF_ALERTS',
  },
  {
    id: 2,
    title: 'Asset Data',
    key: 'ASSET_DATA',
  },
];

const years = [2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010];

class AssetDashboardNew extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reinitialize: true,
      data: [], // for storing data
      tempData2: [], // for filtering data locally
      FilteredFaultData: [], // stores filtered data
      selectedValue: 0, // stores selected object,
      dtResultSet: {
        healthData: [],
        feederData: [],
      },
      filters: {
        fltrdFeeder: [],
        fltrdCable: [],
        fltrdSection: [],
        fltrdCI: [],
        fltrdHI: [],
        fltrdLength: [],
        fltrdAge: [],
        fltrdPOF: [],
      },
      substations: [],
      selectedSub: 2768,
      selectedYear: 2018,
      currentTab: 1,
    };

    this.HandleFaultTableFilteredData =
      this.HandleFaultTableFilteredData.bind(this);
  }

  toggleInfoBox(type) {
    this.props.showHelpbox({
      type,
    });
  }

  componentDidMount() {
    this.bindDDL(2768, 2018);
  }

  // eslint-disable-next-line consistent-return
  onIconActionClick(index) {
    switch (index) {
      case 0:
        this.onReinitilizeClick();
        break;
      case 1:
        // this.showExportDataModal();
        break;
      default:
        return false;
    }
  }

  onReinitilizeClick() {
    document.getElementById('year').value = 2018;
    this.bindDDL(2768, 2018);
  }

  async bindDDL(selectedSub, selectedYear) {
    if (!this.state.reinitialize) {
      this.setState({ reinitialize: true });
    }
    const clientID = session.client();
    try {
      const checkToken = await Auth();
      if (checkToken) {
        Axios.get(`appsconfig/primsubstbyclient/${clientID}`)
          .then((res) => {
            if (res.data.statusCode === 200) {
              const subFromApi = res.data.result.map((div) => ({
                value: div.assetPointId,
                display: div.assetPointName,
              }));
              this.setState({
                substations: [{ value: '', display: '-- Select --' }].concat(
                  subFromApi
                ),
              });
              // const { selectedSub, selectedYear } = this.state;
              document.getElementById('substation').value = selectedSub;

              this.bindData(selectedSub, selectedYear);
            }
          })
          .catch(() => {
            this.setState({
              substations: [{ value: '', display: '-- Select --' }],
            });
          });
      }
    } catch (err) {
      console.log(err);
    }
  }

  setSelected(type, e) {
    const { selectedYear, selectedSub } = this.state;
    let substation;
    let year;
    switch (type) {
      case 'substation':
        substation = e.target.value;
        year = selectedYear;
        break;
      case 'year':
        year = e.target.value;
        substation = selectedSub;
        break;
      default:
        break;
    }
    this.bindData(substation, year);
  }

  getSelected(tab) {
    this.setState({ currentTab: tab });
  }

  async bindData(selectedSubStation, selectedYear) {
    try {
      const checkToken = await Auth();
      if (checkToken) {
        const subValue = selectedSubStation;
        const yerValue = selectedYear;

        // document.getElementById('substation').value = selectedSubStation;
        // document.getElementById('year').value = selectedYear;

        if (subValue !== '' && yerValue !== '') {
          this.setState({
            reinitialize: true,
            selectedSub: selectedSubStation,
            selectedYear,
          });
          Axios.get(
            `assethealth/cablehealthdatabyassetpoint/${subValue}/${yerValue}`
          )
            .then((res) => {
              if (res.data.statusCode === 200) {
                const data = res.data.result.cableSections;
                const fltrdFeeder = [
                  ...new Set(data.map((item) => item.AssetName)),
                ];
                const fltrdCable = [
                  ...new Set(data.map((item) => item.CableAssetName)),
                ];
                const fltrdSection = [
                  ...new Set(data.map((item) => item.CableObjectId)),
                ];
                const fltrdCI = [
                  ...new Set(data.map((item) => item.CriticalityIndex)),
                ].sort();
                const fltrdHI = [
                  ...new Set(data.map((item) => item.HealthIndexBand)),
                ].sort();
                const fltrdLength = [
                  ...new Set(data.map((item) => item.SectionLength)),
                ].sort((a, b) => a - b);
                const fltrdAge = [
                  ...new Set(data.map((item) => item.AgeOfCable)),
                ].sort((a, b) => a - b);
                const fltrdPOF = [
                  ...new Set(data.map((item) => item.POF)),
                ].sort((a, b) => a - b);

                this.setState({
                  data: res.data.result.cableSections,
                  tempData2: res.data.result.cableSections,
                  FilteredFaultData: res.data.result.cableSections,
                  dtResultSet: {
                    healthData: res.data.result.criticalityIndexVsHealthIndex,
                    feederData: res.data.result.feederVsHealthIndex,
                  },
                  filters: {
                    fltrdFeeder,
                    fltrdCable,
                    fltrdSection,
                    fltrdCI,
                    fltrdHI,
                    fltrdLength,
                    fltrdAge,
                    fltrdPOF,
                  },
                  reinitialize: false,
                  selectedValue: 0,
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.setState({
                data: [],
                tempData2: [],
                FilteredFaultData: [],
                dtResultSet: {
                  healthData: [],
                  feederData: [],
                },
                reinitialize: false,
                selectedValue: 0,
              });
            });
        }
      }
    } catch (err) {
      console.log(err);
      this.setState({
        data: [],
        tempData2: [],
        FilteredFaultData: [],
        selectedValue: 0,
        dtResultSet: {
          healthData: [],
          feederData: [],
        },
        reinitialize: false,
      });
    }
  }

  HandleFaultTableFilteredData(filteredData) {
    this.setState({ FilteredFaultData: filteredData });
  }

  onHeatMapBoxClick(val) {
    this.setState({ selectedValue: val });
  }

  // function is triggered when on click of risk reporting box cable health data table click it. filters right side of table as per the data.
  onCableHealthBoxClick(obj) {
    const { CI, HI } = obj;
    // const { data } = this.state;
    // const filteredCIHIData = data.filter(x => x.CriticalityIndex === CI && x.HealthIndexBand === HI);
    // const FilteredFaultData = filteredCIHIData;
    // this.setState({ FilteredFaultData });

    // //check check boxes
    // const fltrCILastVal = CI.charAt(CI.length-1) - 1;
    // const fltrHILastVal = HI.charAt(HI.length-1) - 1;

    // for (var i = 0; i < 4; i++) {
    //     document.getElementById(`fltrCriticalityIndex${i}`).checked = false;
    // }

    // for (var j = 0; j < 5; j++) {
    //     document.getElementById(`fltrHealthIndexBand${j}`).checked = false;
    // }

    // document.getElementById(`fltrCriticalityIndex${fltrCILastVal}`).checked = true;
    // document.getElementById(`fltrHealthIndexBand${fltrHILastVal}`).checked = true;

    const substationId = document.getElementById('substation').value;
    const year = document.getElementById('year').value;

    const dataObj = {
      assetpointId: substationId,
      healthYear: year,
      cI: CI,
      hI: HI,
    };

    this.setState({
      reinitialize: true,
    });
    Axios.post('assethealth/cablehealthfilterdata', dataObj)
      .then((res) => {
        if (res.data.statusCode === 200) {
          const data = res.data.result.cableSections;
          const fltrdFeeder = [...new Set(data.map((item) => item.AssetName))];
          const fltrdCable = [
            ...new Set(data.map((item) => item.CableAssetName)),
          ];
          const fltrdSection = [
            ...new Set(data.map((item) => item.CableObjectId)),
          ];
          const fltrdCI = [
            ...new Set(data.map((item) => item.CriticalityIndex)),
          ].sort();
          const fltrdHI = [
            ...new Set(data.map((item) => item.HealthIndexBand)),
          ].sort();
          const fltrdLength = [
            ...new Set(data.map((item) => item.SectionLength)),
          ].sort((a, b) => a - b);
          const fltrdAge = [
            ...new Set(data.map((item) => item.AgeOfCable)),
          ].sort((a, b) => a - b);
          const fltrdPOF = [...new Set(data.map((item) => item.POF))].sort(
            (a, b) => a - b
          );

          this.setState({
            data: res.data.result.cableSections,
            tempData2: res.data.result.cableSections,
            FilteredFaultData: res.data.result.cableSections,
            filters: {
              fltrdFeeder,
              fltrdCable,
              fltrdSection,
              fltrdCI,
              fltrdHI,
              fltrdLength,
              fltrdAge,
              fltrdPOF,
            },
            reinitialize: false,
            selectedValue: 0,
          });
        } else {
          const fltrdFeeder = [];
          const fltrdCable = [];
          const fltrdSection = [];
          const fltrdCI = [];
          const fltrdHI = [];
          const fltrdLength = [];
          const fltrdAge = [];
          const fltrdPOF = [];

          this.setState({
            data: [],
            tempData2: [],
            FilteredFaultData: [],
            filters: {
              fltrdFeeder,
              fltrdCable,
              fltrdSection,
              fltrdCI,
              fltrdHI,
              fltrdLength,
              fltrdAge,
              fltrdPOF,
            },
            reinitialize: false,
            selectedValue: 0,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          data: [],
          tempData2: [],
          FilteredFaultData: [],
          dtResultSet: {
            healthData: [],
            feederData: [],
          },
          reinitialize: false,
          selectedValue: 0,
        });
      });
  }

  render() {
    const {
      data,
      reinitialize,
      dtResultSet,
      FilteredFaultData,
      currentTab,
      selectedYear,
      selectedSub,
      selectedValue,
      filters,
    } = this.state;

    let selectedSubStation = '';
    if (document.getElementById('substation') !== null) {
      const sel = document.getElementById('substation');
      if (sel.selectedIndex === -1) {
        selectedSubStation = '';
      } else {
        const { text } = sel.options[sel.selectedIndex];
        selectedSubStation = text;
      }
    }

    // let tmpselectedYear = '';
    // if (document.getElementById('year') !== null) {
    //     const sel = document.getElementById('year');
    //     if (sel.selectedIndex === -1) {
    //         tmpselectedYear = '';
    //     } else {
    //         const { text } = sel.options[sel.selectedIndex];
    //         tmpselectedYear = text;
    //     }
    // }

    const ddl = (
      <table className="table table-borderless table-condensed">
        <tr>
          <td width="10%">
            <label>Substation</label>
          </td>
          <td width="30%">
            <select
              id="substation"
              disabled
              defaultValue={selectedSub}
              onChange={(e) => this.setSelected('substation', e)}
              className="form-control"
            >
              {this.state.substations.map((x) => (
                <option key={x.value} value={x.value}>
                  {x.display}
                </option>
              ))}
            </select>
          </td>
          <td width="10%"></td>
          <td width="10%">
            <label>Year</label>
          </td>
          <td width="30%">
            <select
              id="year"
              defaultValue={selectedYear}
              className="form-control"
              onChange={(e) => this.setSelected('year', e)}
            >
              <option value="">-- Select --</option>
              {years.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>
          </td>
        </tr>
      </table>
    );
    return (
      <div>
        <Header
          BrandText={'Asset Health Monitoring'}
          iconsObj={[constants.REFRESH_ICON]}
          islegendObj={true}
          exportObj={exportObj}
          onIconActionClick={this.onIconActionClick.bind(this)}
        />
        {/* //body */}

        <section className="content">
          <div className="row">
            <div id="dv1"></div>
            <div id="dv2"></div>
          </div>

          <AppWidget
            id={'widget1'}
            class={'col-lg-5'}
            infoText={'asset-map'}
            expandText={'MAP'}
            tabs
          >
            <Tabs
              defaultActiveKey={1}
              onSelect={(key) => this.getSelected(key)}
              animation={false}
              id="noanim-tab-example"
            >
              <Tab eventKey={1} title="Heat Map" className={'ds'}>
                {currentTab === 1 && ddl}
                {!reinitialize ? (
                  <div style={{ maxHeight: '65vh', overflowY: 'auto' }}>
                    <HeatMap
                      data={data}
                      selectedValue={selectedValue}
                      onHeatMapBoxClick={this.onHeatMapBoxClick.bind(this)}
                    />
                    <HeatMap2
                      data={data}
                      selectedValue={selectedValue}
                      onHeatMapBoxClick={this.onHeatMapBoxClick.bind(this)}
                    />
                  </div>
                ) : (
                  <ChartLoader height={250} width={400} />
                )}
              </Tab>
              <Tab eventKey={2} title="Risk Reporting Matrix">
                {currentTab === 2 && ddl}
                {reinitialize ? (
                  <ChartLoader height={250} width={400} />
                ) : (
                  dtResultSet.healthData.length > 0 && (
                    <Details
                      criticalityIndexVsHealthIndex={dtResultSet.healthData}
                      selectedSubStation={selectedSubStation}
                      selectedYear={selectedYear}
                      feederVsHealthIndex={dtResultSet.feederData}
                      onCableHealthBoxClick={this.onCableHealthBoxClick.bind(
                        this
                      )}
                    />
                  )
                )}
              </Tab>
            </Tabs>
          </AppWidget>

          <AppWidget
            id={'widget2'}
            class={'col-lg-7'}
            infoText={'asset-table'}
            expandText={'TABLE'}
            tabs={false}
            tabText={'Network Table'}
          >
            {reinitialize ? (
              <TableLoader height={250} width={400} />
            ) : (
              <Table
                data={data}
                filters={filters}
                FilteredFaultData={FilteredFaultData}
                selectedValue={selectedValue}
                passDataToHeatMap={this.onHeatMapBoxClick.bind(this)}
                onFilteredDataChanges={this.HandleFaultTableFilteredData}
              />
            )}
          </AppWidget>
        </section>
      </div>
    );
  }
}

export default AssetDashboardNew;
